import { render, staticRenderFns } from "./PresentationPoster.vue?vue&type=template&id=4c2fe8f6"
import script from "./PresentationPoster.vue?vue&type=script&lang=ts"
export * from "./PresentationPoster.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports